import { GetSatelliteVisibilityResponse } from '@/typings/services/satellite';
import axios from 'axios';

export function getSatelliteVisibility(observer_lat: number, observer_long: number) {
  return axios.get<GetSatelliteVisibilityResponse>(`/gps-visibility/24h`, {
    params: { observer_lat, observer_long },
  });
}
